module.exports = __webpack_public_path__ + "static/media/BannerLpBravectoExperience.615adec8.webp";